import { useEffect, type PropsWithChildren } from 'react'

import {
  LogLevel,
  StatsigProvider as StatsigProviderComponent,
  useClientAsyncInit,
  useStatsigUser,
} from '@statsig/react-bindings'

import { TranslateEnvironment } from '@types'
import { REACT_APP_EXPERIMENTS, REACT_APP_ENV } from 'constants/envs'
import { PageLoader } from 'layouts/loaders'
import { useSelector } from 'stores'

export function StatsigProvider({ children }: PropsWithChildren) {
  const { client, isLoading } = useClientAsyncInit(
    REACT_APP_EXPERIMENTS,
    {},
    {
      logLevel: LogLevel.None,
      environment: { tier: TranslateEnvironment[REACT_APP_ENV] },
    }
  )

  if (isLoading || !client) {
    return <PageLoader />
  }

  return (
    <StatsigProviderComponent client={client}>
      <StatsigUserUpdater />
      {children}
    </StatsigProviderComponent>
  )
}

function StatsigUserUpdater() {
  const userDetail = useSelector((state) => state.user.detail)
  const auth = useSelector((state) => state.auth)
  const { updateUserAsync } = useStatsigUser()

  const { uid, email } = auth.user.data
  const { id, currentCompany } = userDetail.data
  const { id: company_id } = currentCompany
  const userID = id || uid
  const company_type = currentCompany.is_buyer ? 'Merchant' : 'Supplier'

  useEffect(() => {
    if (userID) {
      updateUserAsync((prev) => ({
        ...prev,
        userID,
        ...(email && { email }),
        customIDs: {
          ...prev.customIDs,
          ...(company_id && { company_id }),
          tracker_id: 'webapp',
          ...(company_type && { company_type }),
        },
      }))
    }
  }, [uid, email, userID, company_id, company_type, updateUserAsync])

  return null
}
